module.exports = __webpack_public_path__ + "img/patient_white.f1036986.svg";